module.exports = __webpack_public_path__ + "img/ads-keepgoing-img03.e403871c.jpg";